export default Object.freeze({
  IMAGE: 1,
  QUILL: 2,
  AUDIO: 3,
  VIDEO: 4,
});